import React, { useEffect, useState } from 'react';
import { Stores } from './IndexDb';

/**
 * A React hook that synchronously initializes an IndexedDB database and creates the 'features' object store if it doesn't exist. Returns an object indicating whether the IndexedDB connection is ready.
 *
 * @param databaseName - The name of the IndexedDB database to open or create.
 * @param request - A mutable IDBOpenDBRequest object (passed by reference to be updated).
 * @param db - A mutable IDBDatabase object (passed by reference to be updated).
 * @param version - The database version to use, assigned from db.version on success.
 */
export const useInitIndexDb = (
  databaseName: string,
  request: IDBOpenDBRequest,
  db: IDBDatabase,
  version: number
) => {
  const [isIndexedDbReady, setIsIndexedDbReady] = useState(false);
  const handleInitDB = (databaseName: string): Promise<boolean> => {
    return new Promise((resolve) => {
      // open the connection
      request = indexedDB.open(databaseName);

      request.onupgradeneeded = () => {
        db = request.result;

        // if the data object store doesn't exist, create it
        if (!db.objectStoreNames.contains(Stores.Features)) {
          console.log('Creating features store');
          db.createObjectStore(Stores.Features, { keyPath: 'id' });
        }
        // no need to resolve here
      };

      request.onsuccess = () => {
        db = request.result;
        version = db.version;
        console.log('request.onsuccess - initDB', version);
        resolve(true);
      };

      request.onerror = () => {
        resolve(false);
      };
    });
  };
  useEffect(() => {
    handleInitDB(databaseName).then(() => setIsIndexedDbReady(true));
  }, [databaseName]);

  return { isIndexedDbReady };
};
